<template>
    <div>
        <el-form size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item :label="$t('reports.createdFrom')"
                                  prop="createdOnFrom">
                        <el-date-picker v-model="form.createdOnFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('reports.acceptedDateFrom')"
                                  prop="dateFrom">
                        <el-date-picker v-model="form.dateFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.claimNumber')"
                                  prop="claimNumber">
                        <el-input v-model="form.claimNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.invoiceNumber')"
                                  prop="invoiceNumber">
                        <el-input v-model="form.invoiceNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceTicketNumber')"
                                  prop="serviceTicketNumber">
                        <el-input v-model="form.serviceTicketNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('reports.customerChain')"
                                  prop="chainId">
                        <chain-selector v-model="form.chainId"></chain-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerName')"
                                  prop="customerName">
                        <el-input v-model="form.customerName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerPhone')"
                                  prop="customerPhone">
                        <el-input v-model="form.customerPhone" v-mask="'(###) ###-####'"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serialNumber')"
                                  prop="serialNumber">
                        <el-input v-model="form.serialNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceCoverage')"
                                  prop="serviceCoverage">
                        <service-coverage-selector v-model="form.serviceCoverage"></service-coverage-selector>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('reports.createdTo')"
                                  prop="createdOnTo">
                        <el-date-picker v-model="form.createdOnTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('reports.acceptedDateTo')"
                                  prop="dateTo">
                        <el-date-picker v-model="form.dateTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.status')"
                                  prop="status">
                        <el-select v-model="form.status"
                                   style="width:100%;">
                            <el-option :label="$t('common.new')"
                                       value="1"></el-option>
                            <el-option :label="$t('common.acceptAndProcess')"
                                       value="2"></el-option>
                            <el-option :label="$t('common.moreinfoRequired')"
                                       value="3"></el-option>
                            <el-option :label="$t('common.rejected')"
                                       value="4"></el-option>
                            <el-option :label="$t('reports.modifiedStatus')"
                                       value="5"></el-option>
                            <el-option :label="$t('common.paid')"
                                       value="6"></el-option>
                            <el-option :label="$t('common.pendingReturnPart')"
                                       value="7"></el-option>
                            <el-option :label="$t('common.pendingRepairCodeCorrections')"
                                       value="8"></el-option>
                            <el-option :label="$t('common.correctedRepairCodes')"
                                       value="9"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('common.customerZip')"
                                  prop="customerZip">
                        <el-input v-model="form.customerZip"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceCompany')"
                                  prop="serviceCompany">
                        <el-input v-model="form.serviceCompany"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.partNumber')"
                                  prop="partNumber">
                        <el-input v-model="form.partNumber"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.model')"
                                  prop="productId">
                        <product-selector v-model="form.productId"></product-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.category')"
                                  prop="categoryId">
                        <resolution-category-selector v-model="form.categoryId"
                                                      :productId="form.productId"></resolution-category-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.code')"
                                  prop="codeId">
                        <repair-code-selector v-model="form.codeId"
                                              :productId="form.productId"
                                              :categoryId="form.categoryId"></repair-code-selector>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-checkbox-group v-model="form.fields"
                               ref="group"
                               class="fields">
                <el-row>
                    <el-col :span="12">
                        
                        <el-checkbox class="checkbox"
                                     label="1">{{$t('reports.createdOn')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="3">{{$t('common.invoiceNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="4">{{$t('common.claimNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="45">{{$t('common.serviceTicketNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="5">{{$t('reports.workOrderNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="6">{{$t('common.dateOfDispatch')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="7">{{$t('reports.dateCompleted')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="8">{{$t('common.customerName')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="9">{{$t('reports.customerChain')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="10">{{$t('common.serialNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="11">{{$t('reports.claimReportSymptoms')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="12">{{$t('reports.repairDescription')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="13">{{$t('reports.repairCategory')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="14">{{$t('common.partNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="15">{{$t('reports.laborTime')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="16">{{$t('reports.laborCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="17">{{$t('reports.travelTime')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="18">{{$t('reports.travelCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="19">{{$t('common.mileage')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="20">{{$t('reports.truckCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="21">{{$t('reports.partsCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="22">{{$t('reports.handlingFee')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="44">{{$t('common.ProcessedBy')}}</el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox class="checkbox"
                                     label="2">{{$t('reports.dateProcessed')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="23">{{$t('reports.originalHardtInvoice')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="24">{{$t('reports.freightCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="25">{{$t('reports.salesTax')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="26">Qst/Hst</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="27">Gst</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="28">{{$t('reports.totalCharge')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="29">{{$t('reports.customerAddress')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="30">{{$t('reports.customerCity')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="31">{{$t('reports.customerProvince')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="32">{{$t('reports.customerCountry')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="33">{{$t('reports.customerZip')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="34">{{$t('common.customerPhone')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="35">{{$t('common.serviceCompanyName')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="36">{{$t('reports.serviceCompanyProvince')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="37">{{$t('reports.serviceCompanyZip')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="38">{{$t('common.serviceCoverage')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="39">{{$t('common.model')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="40">{{$t('common.technicianName')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="41">{{$t('reports.tripsNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="42">{{$t('common.status')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="43">{{$t('reports.wasModified')}}</el-checkbox>

                    </el-col>
                </el-row>
            </el-checkbox-group>
            <el-button @click="selectAll">{{$t('common.deSelectAll')}}</el-button>
            <el-button :loading="loading"
                       type="primary"
                       @click="generateReport">{{$t('common.generate')}}</el-button>
        </el-form>
    </div>
</template>

<script>
    import {
        ProductSelector,
        ServiceCoverageSelector,
        ResolutionCategorySelector,
        RepairCodeSelector
    } from "@/app/shared/components";
    import { ChainSelector } from "@/app/masters/customers/components";
    import api from "../api";

    export default {
        name: "claim-history-report",
        components: {
            ChainSelector,
            ProductSelector,
            ServiceCoverageSelector,
            ResolutionCategorySelector,
            RepairCodeSelector
        },
        data() {
            return {
                form: {
                    fields: [],
                    categoryId: null,
                    codeId: null
                },
                loading: false
            };
        },
        watch: {
            "form.productId": function () {
                this.form.categoryId = null;
            },
            "form.categoryId": function () {
                this.form.codeId = null;
            }
        },
        methods: {
            generateReport() {
                this.loading = true;
                api.downloadClaimReport(this.form).then(response => {
                    this.loading = false;
                    var blob = response.data;
                    var fileName = response.headers["content-disposition"]
                        .split(";")[1]
                        .split("=")[1];
                    fileName = fileName.replace(/"/g, '')
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var blobURL = window.URL.createObjectURL(blob);
                        var tempLink = document.createElement("a");
                        tempLink.style.display = "none";
                        tempLink.href = blobURL;
                        tempLink.setAttribute("download", fileName);

                        // Safari thinks _blank anchor are pop ups. We only want to set _blank
                        // target if the browser does not support the HTML5 download attribute.
                        // This allows you to download files in desktop safari if pop up blocking
                        // is enabled.
                        if (typeof tempLink.download === "undefined") {
                            tempLink.setAttribute("target", "_blank");
                        }

                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }
                });
            },
            selectAll() {
                if (this.form.fields.length === 46) {
                    this.form.fields = [];
                } else {
                    for (var i = 1; i <= 46; i++) {
                        this.form.fields.push(i + "");
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .checkbox {
        width: 100%;
        margin-left: 0;
    }

    .fields {
        width: 570px;
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/ClaimHistory.vue